const buttonWidth = 200;

const styles = {
    // Text
    text1: {
        fontSize: '18px',
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.4,
        letterSpacing: 'normal',
        textAlign: 'center',
        color: '#2d3748',
    },
    text2: {
        fontSize: '16px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.4,
        letterSpacing: 'normal',
        textAlign: 'left',
        color: '#2d3748',
    },
    text3: {
        fontSize: '14px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.4,
        letterSpacing: 'normal',
        textAlign: 'left',
        color: '#2d3748',
    },
    text4: {
        fontFamily: 'Helvetica-Light',
        fontSize: '12px',
        fontWeight: 300,
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: '20.4px',
        letterSpacing: '0.48px',
        textAlign: 'left',
        color: '#2d3748',
    },
    // Modal
    searchBarButton: {
        width: buttonWidth,
        borderRadius: (2.67 * buttonWidth) / 2,
        backgroundColor: '#149566',
        height: undefined,
        aspectRatio: 2.67 * buttonWidth
    },

    // Main
    buttonWrapper: {
        all: 'unset',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        marginTop: 10,
        cursor: 'pointer',
    },
};

export default styles;
